import { supabase } from './supabase';

export async function toggleFollow(userId: string) {
  try {
    const { data, error } = await supabase
      .rpc('toggle_follow', {
        target_user_uuid: userId
      });

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error toggling follow:', error);
    throw error;
  }
}

export async function getFollowers(userId: string) {
  try {
    const { data, error } = await supabase
      .from('follows')
      .select(`
        follower:profiles!follower_id(*)
      `)
      .eq('following_id', userId);

    if (error) throw error;
    return data.map(d => d.follower);
  } catch (error) {
    console.error('Error getting followers:', error);
    return [];
  }
}

export async function getFollowing(userId: string) {
  try {
    const { data, error } = await supabase
      .from('follows')
      .select(`
        following:profiles!following_id(*)
      `)
      .eq('follower_id', userId);

    if (error) throw error;
    return data.map(d => d.following);
  } catch (error) {
    console.error('Error getting following:', error);
    return [];
  }
}

export function subscribeToFollows(userId: string, callback: () => void) {
  return supabase
    .channel(`follows:${userId}`)
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'follows',
        filter: `follower_id=eq.${userId}`
      },
      () => callback()
    )
    .subscribe();
}